module.exports = __webpack_public_path__ + "images/72b47a08762b6d54a9a20abd5c3fd529.svg";